<template>
    <div class="text-sm font-semibold">{{ roundedCompensation }} Euro</div>
</template>

<script>
    export default {
        name: "MissionProfileCompensation",
        props: ['compensation'],
        computed: {
            roundedCompensation() {
                try {
                    return Math.round(this.compensation).toLocaleString('de');
                } catch {
                    return this.compensation;
                }
            }
        }
    }
</script>

<style scoped>

</style>